import axios from 'axios'
import { useToast } from 'vue-toastification'
import AlertNotification from '../components/Flashes/AlertNotification.vue'

let apiErrorI = 0

export default async function handleApiError(apiCallback) {
  try {
    return await apiCallback()
  } catch (error) {
    if (axios.isCancel(error)) {
      throw error
    }

    if (error.response.status === 401 && error.response.data?.redirect) {
      window.location.href = error.response.data.redirect
      return
    }

    const toast = useToast()
    
    toast({
      component: AlertNotification,
      props:  {
        alert: 'error',
        heading: error.response.data?.error ? error.response.data.error : 'Error',
        message: error.response.data?.messages ? error.response.data.messages.join(' ') : 'An error occurred while processing your request. Please try again.',
      },
      listeners: {}
    }, {
      id: 'apierror' + (apiErrorI++),
      type: 'error',
    })

    throw error
  } 
}
